applicationDeadline.classy.controller({
    name: 'ApplicationDeadlineController',
    inject: ['$scope', '$rootScope', 'ApplicationService', 'HelpSystemModelService', 'ModelService', 'standardCudArrayFactory', 'SchoolModelService', 'authServiceFactory'],
    init: function()
    {
        this.$.SchoolModelService = this.SchoolModelService;
        this.$rootScope.model = this.SchoolModelService;
        var id = this.SchoolModelService.get()[0].recordID;
        this.$.item = this.SchoolModelService.data[0];
        this.$.versionNo = this.versionNo;
        this.$.formData = {};
        this.$.formData.date = [];
        this.$.opened = [];
        this.$.HelpSystemModelService = this.HelpSystemModelService;

        this.$.html = "<strong>Important!</strong> Deadlines <strong>DO NOT</strong> turn off the system.";

        //Application Deadlines Specific Date Picker Stuff
        for (var i = 1; i < 9; i++)
        {
            //this.convertToNumber(this.$.item['DL' + i + '_active']);
            if ((this.$.item['DL' + i + '_month'] != undefined && this.$.item['DL' + i + '_month'] != "") && (this.$.item['DL' + i + '_day'] != undefined && this.$.item['DL' + i + '_day']))
            {
                if (this.$.item['DL' + i + '_Date'] == undefined)
                {
                    var now = new Date();
                    var deadLine = new Date(new Date().getFullYear(), this.$.item['DL' + i + '_month'] - 1, this.$.item['DL' + i + '_day']);
                    var deadLineFuture = new Date(new Date().getFullYear() + 1, this.$.item['DL' + i + '_month'] - 1, this.$.item['DL' + i + '_day']);
                    if (now - deadLine <= 0)
                        this.$.formData.date[i] = deadLine;
                    else
                        this.$.formData.date[i] = deadLineFuture;
                }
            }
        }

        //Date Picker Stuff
        this.$.dateOptions = { formatYear: 'yy', startingDay: 1, showWeeks: false };
        this.$.minDate = new Date('1900-01-01');
        this.$.maxDate = new Date();
        this.$.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate', 'mmdd'];
        this.$.format = this.$.formats[0];

    },
    convertToNumber: function(dl)
    {
        this.$.item[dl] = Number(this.$.item[dl]);
    },
    open: function($event, index) {
        $event.preventDefault();
        $event.stopPropagation();
        this.$.opened = [];
        this.$.opened[index] = true;
    },
    change: function(date, index)
    {
        this.$.item["DL" + index + "_day"] = Number(date.getDateFormatted());
        this.$.item["DL" + index + "_month"] = Number(date.getMonthFormatted());
    },
    activeChange: function(item, field)
    {
        item[field] = Number(item[field]);     
    },
    submit: function(scope, instance, form)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.SchoolModelService.put(this.id, this.$.item, instance).then(function (response) {

            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.SchoolModelService.set(this.SchoolModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    }

});